module.exports = __webpack_public_path__ + "static/media/ci_old.9a99790e.png";